import {ElementProps, NavLink, NavLinkProps, Stack} from "@mantine/core";
import {Link} from "@tanstack/react-router";
import {
	IconBasket, IconBrandSentry,
	IconCalendar,
	IconIceCream2, IconLogout,
	IconPackage,
	IconPlus,
	IconSettings,
	IconUser
} from "@tabler/icons-react";
import {useUser} from "@state/client/user.store.ts";
import * as Sentry from "@sentry/react";
import {useEffect, useRef} from "react";

interface CustomLinkProps extends NavLinkProps, ElementProps<typeof Link, keyof NavLinkProps> {
}

export const NavbarLink = (props: CustomLinkProps) => <NavLink {...props} component={Link}/>


export default function Navbar() {
	const user = useUser()
	const feedbackRef = useRef(null)

	useEffect(()=>{
		if(feedbackRef.current)
			Sentry.getFeedback()?.attachTo(feedbackRef.current)
	}, [feedbackRef])

	return (
		<Stack h={"100% "}>
			<NavbarLink to={"/orders/new"} leftSection={<IconBasket size={16}/>} label={"Objednávky"}/>
			<NavbarLink to={"/orders/new"} leftSection={<IconPlus size={16}/>} pl={"xl"} label={"Nové"}/>
			<NavbarLink to={"/orders/ready"} leftSection={<IconPackage size={16}/>} pl={"xl"} label={"Vychystané"}/>
			<NavbarLink to={"/dailymenu"} leftSection={<IconCalendar size={16}/>} label={"Denní Nabídka"}/>
			<NavbarLink to={"/dailymenu/today"} leftSection={<IconIceCream2 size={16}/>} pl={"xl"} label={"Dnes"}/>
			<NavbarLink to={"/dailymenu/new"} leftSection={<IconPlus size={16}/>} pl={"xl"} label={"Nová"}/>
			<NavbarLink to={"/items"} leftSection={<IconIceCream2 size={16}/>} label={"Položky"}/>
			<NavbarLink to={"/login"} leftSection={<IconUser size={16}/>} label={"Uživatelé"} disabled/>
			<Stack mt={"auto"}>
				<NavLink onClick={user.logout} leftSection={<IconLogout size={16}/>} hiddenFrom={"md"}
						 label={user.username}/>
				<NavLink ref={feedbackRef} leftSection={<IconBrandSentry size={16}/>} label={"Nahlásit chybu"}/>
				<NavbarLink to={"/settings"} leftSection={<IconSettings size={16}/>} label={"Nastavení"}/>
			</Stack>
		</Stack>
	)
}